<template>
  <section class="data-volume-instance-section">
    <div class="q-py-md">{{ containerPathTitle }}</div>
    <div class="row">
      <policy-string-field
        :disable="disable"
        class="col-6"
        aid="mount-path-input"
        :model-value="modelValue.mountPath"
        no-error-icon
        label="Container path"
        stack-label
        placeholder="e.g: /home/local/data"
        input-class="placeholder-italic"
        :rules="[validationRules.validatePathNotEmpty, validationRules.validatePathFormat]"
        @update:model-value="$emit('update:model-value', { ...modelValue, mountPath: $event })"
        :policy-rules="policyRules?.mountPath"
      />
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent, type PropType } from "vue";
// Components
import { PolicyStringField } from "@/components/common/policy-string-field";
// Models
import type { IUIDataVolumeInstance } from "@/models/workload.model";
import type { DataVolumeRules } from "@/swagger-models/assets-service-client";
// Constants
import { assetsUtil } from "@/utils/assets.util/assets.util";
import { validationRules } from "@/common/validation-rules";

export default defineComponent({
  name: "data-volume-instance-section",
  components: {
    PolicyStringField,
  },
  emits: ["update:model-value"],
  props: {
    modelValue: {
      type: Object as PropType<IUIDataVolumeInstance>,
      required: true,
    },
    policyRules: {
      type: [Object, null] as PropType<DataVolumeRules | null>,
      required: false,
    },
    disable: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  data() {
    return {
      validationRules,
    };
  },
  computed: {
    containerPathTitle(): string {
      return assetsUtil.containerPathTitle();
    },
  },
});
</script>
